import React, { useMemo } from 'react';
import RoutedLayout from 'components/Layout/RoutedLayout';
import useDataSource from 'hooks/useDataSource';
import { hasModuleLicense } from 'shared/utils/license';
import { Module } from 'shared/services/prisma/types';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { EDIT_LICENSE } from 'shared/constants/permissions';
import useUser from 'hooks/useUser';
import Loading from 'components/Loading';
import routes from './routes';

const extraFields = `
  website {
    id
    matomoId
    matomoHeatmaps {
      id
      matomoHsrId
      name
    }
    matomoSessionRecordings {
      id
      matomoHsrId
      name
    }
  }
`;

const Hsr = () => {
  const { isSuperUser } = useUser();
  const { dataSource, dataSourceId, loading, hasDataSourcePermission } = useDataSource({ extraFields });

  const hasHsr = hasModuleLicense(dataSource?.activeLicense, Module.Heatmaps);

  const dynamicRoutes = useMemo(() => routes.map(route => {
    if (route.path === 'heatmaps') {
      const hsrRoutes = dataSource?.website?.matomoHeatmaps.map(h => ({
        path: h.matomoHsrId,
        label: h.name,
      })) || [];

      return {
        ...route,
        children: hsrRoutes,
      };
    }

    if (route.path === 'session-recordings') {
      const hsrRoutes = dataSource?.website?.matomoSessionRecordings.map(h => ({
        path: h.matomoHsrId,
        label: h.name,
      })) || [];

      return {
        ...route,
        children: hsrRoutes,
      };
    }

    if (route.path === 'session-recordings-new') {
      const hsrRoutes = dataSource?.website?.matomoSessionRecordings.map(h => ({
        path: h.matomoHsrId,
        label: h.name,
      })) || [];

      return {
        ...route,
        children: hsrRoutes,
        props: { sessionRecordings: dataSource?.website?.matomoSessionRecordings },
      };
    }

    return route;
  }), [dataSource]);

  if (loading) {
    return <Loading />;
  }

  if (!isSuperUser && !hasHsr) {
    return (
      <Result
        status="info"
        title="No license"
        subTitle="You need to have a license for Heatmaps & recordings to view this page."
        extra={hasDataSourcePermission(EDIT_LICENSE) ? (
          <Link to={`/data-sources/${dataSourceId}/settings/license`}>
            <Button type="primary">Upgrade license</Button>
          </Link>
        ) : (
          <>Ask the owner to setup a license.</>
        )}
      />
    );
  }

  return (
    <RoutedLayout className="module-heatmaps" sidebar routes={dynamicRoutes} />
  );
};

export default Hsr;
